class PredictiveSearch extends SearchForm {
    constructor() {
      super();
      this.cachedResults = {};

      this.selectors = {
        productItem: '.predictive-search__list-item--product'
      }
      
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
      this.popularSeachItems = this.querySelectorAll('.js-popular-search-item');
      this.popularSearchWrapper = this.querySelector('.popular-search-wrapper');

      this.resultsWrapper = this.querySelector('.js-predictive-search__results-groups-wrapper');

      this.productResultsWrapper = this.querySelector('.js-product-results-wrapper');
      this.productResultsContainer = this.querySelector('.js-predictive-search__results-list')

      this.collectionResultsWrapper = this.querySelector('.js-collection-results-wrapper')
      this.collectionResultsContainer = this.querySelector('.js-predictive-search__collection-results-list');

      this.isOpen = false;
      this.abortController = new AbortController();
      this.searchTerm = '';
      this.isFetching = false;
      this.loadingClass = "is-loading"

      this.PRODUCT_LIMIT = 5;

      this.PRODUCT_FETCH_URL = `${window.theme.apiUrl}/api/ai/search/peek/`;
  
      this.setupEventListeners();

      //init analytics service
      this.INTER_URL = `${window.theme.apiUrl}/api/ai/search/analytics/interaction`;
      this.IMP_URL = `${window.theme.apiUrl}/api/ai/search/analytics/impression`;

      this.analyticsService = new window.AnalyticsService({
          impressionUrl: this.IMP_URL,
          interactionUrl: this.INTER_URL,
          idleMs: 15000,
          currency: window.theme?.currency || 'USD'
      });

      this.analyticsService.configureImpressions({
          container: this.productResultsContainer,
          limit: this.PRODUCT_LIMIT,
          productItemSelector: this.selectors.productItem,
          loadingClass: this.loadingClass
      });
    }
  
    setupEventListeners() {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
  
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));

      this.popularSeachItems.forEach((item) =>{
        item.addEventListener('click', this.onClickPopularSearchItem.bind(this))
      })

      this.input.addEventListener('change', this.onInputChange.bind(this));

      // 👇 new scroll event
      this.predictiveSearchResults.addEventListener('scroll', this.onResultsScroll.bind(this));

      // Abort on navigate-away
      const abortOnHide = () => this.abortController.abort();
      window.addEventListener('pagehide', abortOnHide);       // best for SPA & iOS
      window.addEventListener('beforeunload', abortOnHide);   // legacy fallback
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') abortOnHide();
      });

      this.productResultsContainer.addEventListener('click', this.handleProductResultClick.bind(this));
      
  }
  


    
    onResultsScroll() {
      //only enable for mobile
      if (window.innerWidth <= 768) {
        this.input.blur();
      }
    }

    onInputChange(){
      let val = this.getQuery();
      
      if(this.popularSearchWrapper){
        if(val.length == 0){
          this.popularSearchWrapper.style.display = "block";
        }else {
          this.popularSearchWrapper.style.display = "none"
        }
      }
    }

    onClickPopularSearchItem(event){
      let target = event.target;

      let searchTerm = target.innerText;

      const url = `${window.routes.search_url}?search=${encodeURIComponent(searchTerm)}`

      window.location.href = url;

      /*

      this.input.value = searchTerm;
      this.input.focus();

      //remove placeholder
      this.controlPlaceholder();
      this.onChange();

      //hide search after clickings
      this.popularSearchWrapper.style.display = "none"; 

      */

    }
  
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
      super.onChange();
      const newSearchTerm = this.getQuery();

      console.log('new search: ', newSearchTerm);

      if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
        this.clearResults();
      }
  
      // Update the term asap, don't wait for the predictive search query to finish loading
      this.updateSearchForTerm(this.searchTerm, newSearchTerm);
  
      this.searchTerm = newSearchTerm;

      // hide suggested search when user starts typing
      if(this.popularSearchWrapper){
        if(!this.searchTerm.length){
          this.popularSearchWrapper.style.display = "block";
        }else {
          this.popularSearchWrapper.style.display = "none"
        }
      }

      
  
      if (!this.searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(this.searchTerm);
      
    }
  
    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }
  
    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.searchTerm = '';
        this.abortController.abort();
        this.abortController = new AbortController();
        this.closeResults(true);
      }
    }
  
    onFocus() {
      const currentSearchTerm = this.getQuery();
  
      if (!currentSearchTerm.length) return;
  
      if (this.searchTerm !== currentSearchTerm) {
        // Search term was changed from other search input, treat it as a user change
        this.onChange();
      } else if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }
  
    onFocusOut() {
      //close only on desktop
      if (window.innerWidth > 768) {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }
    }
  
    onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();
  
      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }
  
    onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }
  
    updateSearchForTerm(previousTerm, newTerm) {
      const searchForTextElement = this.querySelector('.js-search-for-text');
      const currentButtonText = searchForTextElement?.innerText;
      /*
      
      if (currentButtonText) {
        if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
          // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
          return;
        }
        const newButtonText = currentButtonText.replace(previousTerm, newTerm);
        searchForTextElement.innerText = newButtonText;
      }
      */
      console.log('Previous Term:', previousTerm, newTerm);
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  
    switchOption(direction) {
      if (!this.getAttribute('open')) return;
  
      const moveUp = direction === 'up';
      const selectedElement = this.querySelector('[aria-selected="true"]');
  
      // Filter out hidden elements (duplicated page and article resources) thanks
      // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
      const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
        (element) => element.offsetParent !== null
      );
      let activeElementIndex = 0;
  
      if (moveUp && !selectedElement) return;
  
      let selectedElementIndex = -1;
      let i = 0;
  
      while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
        if (allVisibleElements[i] === selectedElement) {
          selectedElementIndex = i;
        }
        i++;
      }
  
      this.statusElement.textContent = '';
  
      if (!moveUp && selectedElement) {
        activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
      } else if (moveUp) {
        activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
      }
  
      if (activeElementIndex === selectedElementIndex) return;
  
      const activeElement = allVisibleElements[activeElementIndex];
  
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
  
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }
  
    selectOption() {
      const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
  
      if (selectedOption) selectedOption.click();
    }
  
    getSearchResults(searchTerm) {
      
      const queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLiveRegionLoadingState();
  

      if (this.cachedResults[queryKey]) {
        console.log('returning cached results from predictive search');
        this.clearResults();
        this.renderSearchResults(this.cachedResults[queryKey]);
        this.classList.remove('loading');
        return;
      }


      const locale = (window.theme.apiLocale || 'us').toLowerCase();
      const params = new URLSearchParams({
        search: searchTerm,
        locale,
        placement: "topBar"
      }).toString();

      this.abortController?.abort('new-query');
      this.abortController = new AbortController();
  
      fetch(`${this.PRODUCT_FETCH_URL}?${params}`, {
        credentials: 'include',
        signal: this.abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.clearResults();
            this.handleNoResults();
            throw error;
          }
  
          return response.json();
        })
        .then((response) => {

          // Save bandwidth keeping the cache in all instances synced
          this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = response;
          });

          this.clearResults();
          this.renderSearchResults(response);
        })
        .catch((error) => {

          this.clearResults();
          this.handleNoResults();

          if (error?.code === 20) {
            console.log('Call Aborted', error)
            // Code 20 means the call was aborted
            return;
          }
          throw error;
        })
        .finally(() => {
          this.classList.remove('loading');
        })
  }
  
  clearResults() {
    //clear product results
    this.productResultsContainer.innerHTML = "";
    //clear collections results
    this.collectionResultsContainer.innerHTML = "";

    this.resultsWrapper.classList.remove('no-results')
    
    this.resetAnalyticsService();
  }

  resetAnalyticsService() {
    //reset impressions
    if (!this.analyticsService) return;

    this.analyticsService.resetImpressions();
    this.analyticsService.setSearchId(null);
  }
  
    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
  
      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
      this.classList.add('loading');
    }
  
    setLiveRegionText(statusText) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
  
      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }
  
  renderSearchResults(results) {

    const { collections, title, products, search, searchId, pagination } = results;

    if (search == "no results") {
      this.handleNoResults();
      return;
    }

    //set searchid for analytics
    this.analyticsService.setSearchId(searchId);

    this.renderProducts(products, searchId);
    this.renderCollections(collections);

    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();


    //trigger analytics
    const initialPage = (pagination && Number.isInteger(pagination.page)) ? pagination.page : 0;
    //this.analyticsService.observePageByItem(initialPage);

    this.analyticsService.sendPeekImpression(0, {
      start: 0,
      end: this.PRODUCT_LIMIT - 1 //index-0 so minus 1 to the limit
    })

    
  }

  handleProductResultClick(event) {
    const productElement = event.target.closest('.predictive-search__list-item--product');
    if (productElement) {
      
      const handle = productElement.dataset.handle;
      this.analyticsService.trackClick(handle)
    }
  }

  handleNoResults() {
    this.resultsWrapper.classList.add('no-results')
  }
    
  renderProducts(products, searchId) {
  
    //only first 5
    products = products.slice(0, this.PRODUCT_LIMIT);

    products.forEach((product, i) => {
      const amount = Number.parseFloat(product.priceRangeV2?.minVariantPrice.amount).toFixed(2);
      const imgUrl   = `${product.featuredImage?.url}&width=800`;
      const money    = slate.Currency.formatMoney(
                          amount.toString(),
                          theme.moneyFormat
                      );

      const template = `<li id="predictive-search-option-product-${i}" class="predictive-search__list-item predictive-search__list-item--product"
        role="option" aria-selected="false" data-handle="${product.handle}">
            <a href="${window.routes.root_url}/products/${product.handle}?searchId=${searchId}" class="predictive-search__item " tabindex="-1">
                <img class="predictive-search__image" src="${imgUrl}"
                alt="${product.title}" 
                width="50"
                height="50">
                <div
                class="predictive-search__item-content predictive-search__item-content--centered">
                <p class="predictive-search__item-heading link-animate-underline ">
                    ${product.title}
                </p>
                </div>
            </a>
        </li>`;

      const tpl = document.createElement("template");
      tpl.innerHTML = template

      this.productResultsContainer.appendChild(tpl.content.firstElementChild);

      //attach event listeners to results for analytics
      this.productResultsContainer.querySelectorAll(this.selectors.productItem).forEach((item) => {
        console.log('add item');
        item.addEventListener('click', this.handleProductItemClick.bind(this));
      })
    });

  }

  handleProductItemClick(event) {

    const el = event.target.closest(this.selectors.productItem);

    if (!el) return;

    const handle = el.dataset.handle;
    this.analyticsService.trackClick(handle);
  }

  renderCollections(collections) {

    if (!collections || collections.length < 1) {
      this.collectionResultsWrapper.style.display = "none"
      return;
    } else {
      this.collectionResultsWrapper.style.display = "flex"
    }

    //only first 5
    collections = collections.slice(0, 5);

    collections.forEach((collection, i) => {
      const url = `${window.routes.root_url}/collections/${collection.handle}`

      const template = `<li id="predictive-search-option-collection-${i}" class="predictive-search__list-item"
                    role="option" aria-selected="false">
                    <a href="${url}" class="predictive-search__item link link--text" tabindex="-1">
                        <div class="predictive-search__item-content predictive-search__item-content--centered">
                        <p class="predictive-search__item-heading">${collection.title}</p>
                        </div>
                    </a>
                    </li>`;

      const tpl = document.createElement("template");
      tpl.innerHTML = template

      this.collectionResultsContainer.appendChild(tpl.content.firstElementChild);

    });
    
  }
    
    setLiveRegionResults() {
      this.removeAttribute('loading');
      this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }
  
    getResultsMaxHeight() {
      this.resultsMaxHeight =
        window.innerHeight - document.querySelector('.site-header').getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }
  
    open() {
      this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }
  
    close(clearSearchTerm = false) {
      this.abortController?.abort('ui-close');
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }
  
    closeResults(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
      const selected = this.querySelector('[aria-selected="true"]');
  
      if (selected) selected.setAttribute('aria-selected', false);
  
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('loading');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      this.predictiveSearchResults.removeAttribute('style');
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  